import { render, staticRenderFns } from "./TrucksTrailersResultTable.vue?vue&type=template&id=72bf7487&"
import script from "./TrucksTrailersResultTable.vue?vue&type=script&lang=js&"
export * from "./TrucksTrailersResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports